// maintain alphabetical order
export const enBrandsDashboard = {
  BrandsDashboardDrillMessage: 'Drill into any object by clicking on the graph or table below.',
};